
export default function LocationsSection() {
  const locations = [
    {
      name: "IDS佐賀教習所",
      company: "株式会社アイテム",
      address: "佐賀県多久市北多久町大字小侍4771",
      phone: "0952-71-9855",
      coverage: "佐賀県西部(佐賀市含)・中山間地域",
      features: "中山間得意/川副と共同でRTK基地局設置・無償提供"
    },
    {
      name: "IDS川副教習所",
      company: "九三エンジニアリング株式会社",
      address: "佐賀県佐賀市川副町小々森146-1",
      phone: "0952-97-5291",
      coverage: "佐賀県東部(佐賀市含)・福岡県南部(柳川・大川・みやま)",
      features: "平野部中心/佐賀とRTK共有化・無償提供"
    },
    {
      name: "IDS鹿児島教習所",
      company: "株式会社エコナーセリー",
      address: "鹿児島県日置市伊集院町古城795",
      phone: "099-213-9466",
      coverage: "鹿児島県全域",
      features: "FAG-RTK完備/他社より低価格/将来無償化検討"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            全国3拠点で広域サポート
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {locations.map((location, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-center justify-center w-16 h-16 bg-[#2A6041] text-white rounded-full mx-auto mb-6">
                <i className="ri-map-pin-line text-2xl"></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
                {location.name}
              </h3>
              <p className="text-gray-600 text-center mb-4">
                {location.company}
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <a 
                    href={`tel:${location.phone}`} 
                    className="text-[#2A6041] font-bold hover:text-[#1a4029] transition-colors cursor-pointer text-lg"
                  >
                    📞 {location.phone}
                  </a>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-map-pin-2-line text-[#2A6041] mr-3 mt-1 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm">{location.address}</span>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-time-line text-[#2A6041] mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-gray-700 text-sm font-medium">受付時間: 平日9:00〜17:00</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-map-line text-[#2A6041] mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-gray-700 text-sm font-medium mb-1">対応エリア:</p>
                    <p className="text-gray-600 text-sm">{location.coverage}</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-star-line text-[#2A6041] mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <p className="text-gray-700 text-sm font-medium mb-1">特徴:</p>
                    <p className="text-gray-600 text-sm">{location.features}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
